import {
  AlertTriangle,
  Bell,
  Building2,
  Calendar,
  CheckCircle2,
  Clock,
  Cloud,
  CreditCard,
  Database,
  File,
  FileText,
  Folder,
  Globe,
  Lock,
  Mail,
  MessageSquare,
  Package,
  Phone,
  Printer,
  Server,
  Settings,
  ShoppingCart,
  Truck,
  User,
  Users,
  Wrench,
  XCircle,
  Zap,
  type LucideIcon,
} from 'lucide-react';

// Catálogo fixo de ícones disponíveis para os nós do fluxograma. A chave é o
// que fica salvo em `style.icon`; o valor é o componente lucide a renderizar.
export const ICON_MAP: Record<string, LucideIcon> = {
  user: User,
  users: Users,
  mail: Mail,
  phone: Phone,
  file_text: FileText,
  file: File,
  folder: Folder,
  database: Database,
  server: Server,
  cloud: Cloud,
  settings: Settings,
  alert_triangle: AlertTriangle,
  check_circle: CheckCircle2,
  x_circle: XCircle,
  clock: Clock,
  calendar: Calendar,
  shopping_cart: ShoppingCart,
  credit_card: CreditCard,
  truck: Truck,
  package: Package,
  building: Building2,
  globe: Globe,
  lock: Lock,
  bell: Bell,
  message: MessageSquare,
  printer: Printer,
  wrench: Wrench,
  zap: Zap,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP) as Array<keyof typeof ICON_MAP>;
